import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Home  from './pages/Home';

function AppContent() {
  const { user, token, driver, loading, logout } = useAuth();
  if (loading) return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background:'#0f0c29',color:'#fff',fontSize:'24px'}}>⏳</div>
  );
  return user
    ? <Home user={user} token={token} driver={driver} onLogout={logout} />
    : <Login />;
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>;
}
